import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getCourseData } from '../../Redux/ActionCreater';
import CourseData from './CourseData';
import { FaAngleUp } from "react-icons/fa";
import $ from "jquery";
function Course() {
    const [course,setCourse]=useState();
    const [loading,setLoading]=useState(true);
    const dispatch = useDispatch();
    const state = useSelector(
      (state) => (
         state.dataReducer
      ),
      shallowEqual
    );
    useEffect(() => {
        fetchData();
        $(document).ready(function () {
          $(window).scroll(function () {
            if ($(this).scrollTop() > 100) {
              $('.scrolltop').fadeIn();
            } else {
              $('.scrolltop').fadeOut();
            }
          });
          $('.scrolltop').click(function () {
            $("html, body").animate({
              scrollTop: 0
            }, 600);
            return false;
          });
        });
      }, [])

      const fetchData = async () => {
      
        let header={
          headers:{
          "X-Auth-Token":"12345"
        }};
        dispatch(getCourseData(header));
        
      };

      useEffect(() => {
        setCourse(state.courseData);
        setLoading(state.isLoading)
        }, [state])
  return (
    <>
    <Helmet>
          <title>{`CNC Machine :: Course`}</title>
          {/* <meta name="description" content={res?.meta_description} />
          <meta name="keywords" content={res?.meta_keywords} />
          <meta name="title" content={res?.meta_title} /> */}
          <meta property="og:title" content="CNC Machine :: Course"/>
          
        </Helmet>
    {loading===true?<div className="loader-container">
        <div className="spinner"></div>
      </div>:
      <CourseData data={course}/>
    }
    <a class="scrolltop" href="" style={{display:"none"}}>
      {/* <i class="fa fa-angle-up"></i> */}
    <i><FaAngleUp/></i>
    </a>
    </>
  )
}

export default Course